export function Invoice() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5185_4690)">
        <path
          d="M8.3984 1.49976H13.5896C14.418 1.49976 15.0896 2.17133 15.0896 2.99976V14.9998C15.0896 15.8282 14.418 16.4998 13.5896 16.4998H4.5896C3.76117 16.4998 3.0896 15.8282 3.0896 14.9998V6.80858C3.0896 6.41075 3.24763 6.02922 3.52894 5.74791L7.33776 1.9391C7.61907 1.65779 8.0006 1.49976 8.3984 1.49976Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDashoffset="round"
        />
        <path
          d="M3.0896 6.74976H8.3396V1.49976"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDashoffset="round"
        />
        <path
          d="M6.0896 12.7498H12.0896"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDashoffset="round"
        />
        <path
          d="M6.0896 9.74976H8.3396"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDashoffset="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5185_4690">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.0895996 -0.000244141)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
